import schema from './schema.json'

interface GraphType {
  name: string
  possibleTypes: GraphType[] | null
}

const buildPossibleTypes = () => {
  if (!schema) return {}

  const types = schema.__schema.types as GraphType[]

  const results = types
    .filter((type: GraphType) => type.possibleTypes)
    .reduce(
      (memo, type: GraphType) => {
        if (type.name)
          memo[type.name] = type.possibleTypes?.map((sub) => sub.name) || []

        return memo
      },
      {} as Record<string, string[]>,
    )

  return results
}

export default buildPossibleTypes
